import * as React from 'react';
import { connect } from 'react-redux';
import { ProgressBar, Image, Button, Dropdown, Form } from 'react-bootstrap';
import { CAR_REGISTRATION, VEHICLE_LOOKUP } from '../../../routes/routes';
import { navigateTo } from '../../../actions/navigationActions';
import './CarDetails.css';
import { postToController } from '../../../actions/apiActions';
import { setCarDetails, setFinanceHouse } from '../../../actions/salesActions';

class CarDetails extends React.PureComponent<any, any> {
    constructor(props: any) {
        super(props);
        this.state = {
            hasSelectedFin: false,
            editYear: "",
            yearsDropdownOpen: false,
            loggedIn: this.props.auth.uid ? true : false,
            selectedItem: "",
            cursor: 0,
            searchItems: [],
            yearList: [],
            financeHouseList: [],
            nextDisabled: true,
            openDisabled: true,
            selectedFinanceHouse: "",
            selectedFinanceHouseId: -1,
            selectedFinanceHouseDropdown: false,
            buttonYesClicked: false,
            buttonNoClicked: false,
            isFinanceYes: false,
        }

        this.autocomplete = this.autocomplete.bind(this);
        this.hanldeKeyup = this.hanldeKeyup.bind(this);
        this.hanldeKeydown = this.hanldeKeydown.bind(this);
        this.handleListKeydown = this.handleListKeydown.bind(this);
        this.selectItem = this.selectItem.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleYearsDropdownToggle = this.handleYearsDropdownToggle.bind(this);
        this.handleYearsSelection = this.handleYearsSelection.bind(this);
        this.componentDidMount = this.componentDidMount.bind(this);

        this.handleClick = this.handleClick.bind(this);
        this.handleBack = this.handleBack.bind(this);
        this.getFinanceHouses = this.getFinanceHouses.bind(this);
        this.handleFinanceSelection = this.handleFinanceSelection.bind(this);
        this.handleSelectedFinanceHouseDropdownToggle = this.handleSelectedFinanceHouseDropdownToggle.bind(this);
        this.handleYesButton = this.handleYesButton.bind(this);
        this.handleNoButton = this.handleNoButton.bind(this);
    }

    async componentDidMount() {
        if (this.state.financeHouseList.length === 0) {
            await this.getFinanceHouses();
        }

        if (this.state.yearList.length === 0) {
            await this.getYearList();
        }
    }

    async handleBack(e: any) {
        this.props.redirectTo(CAR_REGISTRATION);
    }

    async handleYesButton() {
        await this.setState({ hasSelectedFin: true });

        if (this.state.editYear !== "" && this.state.selectedItem !== "") {

            await this.setState({ openDisabled: false, buttonNoClicked: false });
            await this.setState({ nextDisabled: true, buttonYesClicked: true, isFinanceYes: true });
        } else {
            await this.setState({ nextDisabled: true, buttonYesClicked: true, isFinanceYes: true });
        }
    }

    async handleNoButton() {
        await this.setState({ hasSelectedFin: true });
        if (this.state.editYear !== "" && this.state.selectedItem !== "") {
            await this.setState({ openDisabled: true, buttonNoClicked: true });
            await this.setState({ nextDisabled: false, buttonYesClicked: false, isFinanceYes: false });
        }
    }

    async handleClick() {
        if (this.state.editYear !== "" && this.state.selectedItem != "") {
            this.props.dispatchSetCarDetails(this.state.editYear, this.state.selectedItem.vehicleMake.id, this.state.selectedItem.vehicleModel.id, this.state.selectedItem.vehicleSeries.id, this.state.selectedItem.vehicleSeries.mmCode, this.state.selectedItem.fullDescription);
            if (this.state.selectedFinanceHouse !== "" && this.state.selectedFinanceHouseId !== -1) {
                this.props.dispatchSetFinanceHouse(this.state.selectedFinanceHouse, this.state.selectedFinanceHouseId);
            }
        }
    }

    async handleFinanceSelection(e: any) {
        await this.setState({ nextDisabled: false });
        let coverItem = this.state.financeHouseList.filter(function (item) {
            return item.id == e
        })
        await this.setState({
            selectedFinanceHouse: coverItem[0].description,
            selectedFinanceHouseId: coverItem[0].id,
        });

    }

    async getFinanceHouses() {
        await postToController(this.props.dispatch, 'GetFinanceHouses', JSON.stringify({ Parameter: this.props.profile.countryId })).then(async (response) => {
            await this.setState({ financeHouseList: response });
            return true;
        })
    }

    async handleSelectedFinanceHouseDropdownToggle(e: any) {
        await this.setState({
            selectedFinanceHouseDropdown: !this.state.selectedFinanceHouseDropdown
        });
    }

    async autocomplete(evt) {
        let text = evt.target.value;
        var listmax = 50;   //Make the search quicker - can't return full list
        var items = [];
        await this.setState({ selectedItem: text });
        await this.setState({ searchItems: [] });

        if (text && text.length >= 3 && this.state.editYear !== "") {
            await postToController(this.props.dispatch, 'VehicleSearch', JSON.stringify({ Year: parseInt(this.state.editYear), SearchText: text }))
                .then(async (response) => {
                    if (response) {
                        items = response
                            .filter((i, index) => (index < listmax))
                            .map((i, index) => {
                                return (
                                    i
                                );
                            });

                        await this.setState({ searchItems: items });
                    }
                });
        }
    }

    hanldeKeyup(evt) {
        if (evt.keyCode === 27) {
            this.setState({ searchItems: [] });
            return false;
        }
    }

    hanldeKeydown(evt) {
        const { cursor, searchItems } = this.state;
        // arrow up/down button should select next/previous list element
        if (evt.keyCode === 38 && cursor > 0) {
            this.setState(prevState => ({
                cursor: prevState.cursor - 1
            }));
        } else if (evt.keyCode === 40 && cursor < searchItems.length - 1) {
            this.setState(prevState => ({
                cursor: prevState.cursor + 1
            }));
        }
        if (evt.keyCode === 13) {
            let currentItem = searchItems[cursor];
            if (currentItem !== undefined) {
                this.setState({ searchItems: [] });
            }
        }
    }

    selectItem(item) {
        this.setState({ selectedItem: item });
        this.setState({ searchItems: [] });
    }

    handleListKeydown(evt) {
    }

    handleChange(evt) {
        this.setState({ item: { [evt.target.name]: evt.target.value } });
    }

    async handleYearsSelection(year: any) {
        await this.setState({ editYear: year });
    }

    async handleYearsDropdownToggle(e: any) {
        await this.setState({
            yearsDropdownOpen: !this.state.yearsDropdownOpen
        });
    }

    handleDontKnow() {
        this.props.redirectTo(VEHICLE_LOOKUP);
    }

    async getYearList() {
        let result: string[] = [];
        var currentYear = new Date().getFullYear() - 1, years = [];
        var startYear = currentYear - 20;

        while (startYear <= currentYear) {
            startYear++
            result.push(startYear.toString());
        }
        await this.setState({ yearList: result.reverse() });
    }

    public render() {
        let yearDrop = [];
        if (this.state.yearList.length > 0) {
            yearDrop = this.state.yearList.map((item) => {
                return <Dropdown.Item key={item} eventKey={item}>{item}</Dropdown.Item>
            });
        }

        let financeHouseDrop = [];
        if (this.state.financeHouseList.length > 0) {
            financeHouseDrop = this.state.financeHouseList.map((item) => {
                return <Dropdown.Item key={item.id} eventKey={item.id}>{item.description}</Dropdown.Item>
            });
        }

        return (
            <>
                <div id="CarDetails" className={this.state.loggedIn ? "pt-lg-2 p-lg-0 mt-0 logged-in" : "pt-lg-2 p-lg-02 mt-0 logged-out"}>
                    <div className="col-12 text-lg-center text-md-center">
                        <div className="container">
                            <div className="row justify-content-center">
                                <div className="col-lg-10 col-md-12">
                                    <div className="row justify-content-center">
                                        <div className="col-2 col-md-3 col-lg-3 col-xl-2 pt-lg-2 text-center align-self-center">
                                            <div className="BackRectangle d-none d-lg-block d-md-block">
                                                <button onClick={this.handleBack} className="Back cursor-pointer"><img src="./images/OnlineQuotation/icon-back-button-desktop.png" alt="" /></button>
                                            </div>
                                            <div className="sidenav d-lg-none d-md-none" id="mySidenav">
                                                <button onClick={this.handleBack} className="Back cursor-pointer" id="about"><img src="./images/OnlineQuotation/icons-navigation-quote-back-btn.png" alt="" /></button>
                                            </div>
                                        </div>
                                        <div className="col-10 col-md-9 col-lg-9 col-xl-10 p-0 text-center align-self-center">
                                            <div>
                                                <ProgressBar variant="success" now={35} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="container">
                            <div className="row justify-content-center">
                                <div className="col-lg-10 col-md-12">
                                    <div className="mt-5 text-center">
                                        <img src="./images/OnlineQuotation/crown-icon.png" alt="" className="img-fluid" />
                                    </div>
                                    <div className="ma-top-21px text-center">
                                        <p className="text-16 font-weight-500">Can you give me the year, make and <br />model of your car</p>
                                    </div>
                                    <div className="form-row noma car-extra-info">
                                        <div className="col-12 nopa">
                                            <p className="mb-0px font-weight-bold">Please note that cars used for any of the following purposes are not covered by the king:</p>
                                        </div>
                                        <div className="col-12 nopa">
                                            <ul className="mb-0px pl-25px">
                                                <li>Emergency services,</li>
                                                <li>Armed response,</li>
                                                <li>Law enforcement,</li>
                                                <li>Driving instructions,</li>
                                                <li>Towing purposes,</li>
                                                <li>Rental purposes,</li>
                                                <li>Taxis or transporting of fare paying passengers.</li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div className="form-row noma mt-30px mb-lg-1 mb-2">
                                        <div className="col-12 nopa">
                                            <div className={'form-group' + (this.state.editYear ? ' has-error' : '')}>
                                                <Form.Label className={'left-align temp-text-box-label pl-1' + (this.state.editYear !== "" ? "" : " no-opacity")}>Year</Form.Label>

                                                <Dropdown
                                                    id="years-select-dropdown"
                                                    onSelect={this.handleYearsSelection}
                                                    onToggle={this.handleYearsDropdownToggle}
                                                    className="fit-full mb-0">
                                                    <Dropdown.Toggle variant="success" id="dropdown-basic" >
                                                        <div className="row dropdown-height">
                                                            <div className="dropdown-basic-title-text col-11">
                                                                {this.state.editYear}
                                                                {!this.state.editYear &&
                                                                    <p>Year</p>
                                                                }
                                                            </div>
                                                            <Image src='Images/red-arrow-up-24-px.svg' className={this.state.yearsDropdownOpen ? 'visible' : 'invisible'} alt="" />
                                                            <Image src='Images/red-arrow-down-24-px.svg' className={this.state.yearsDropdownOpen ? 'invisible' : 'visible'} alt="" />
                                                        </div>
                                                    </Dropdown.Toggle>

                                                    <Dropdown.Menu id='yearsDropDown'>
                                                        {yearDrop}
                                                    </Dropdown.Menu>
                                                </Dropdown>

                                                {(this.state.editYear === "" && this.state.selectedItem !== "" && this.state.hasSelectedFin) ||
                                                    (this.state.editYear === "" && this.state.selectedItem === "" && this.state.hasSelectedFin) &&
                                                    <div className="help-block mt-0">Year is required</div>
                                                }

                                            </div>
                                            <div className="form-group mb-0">
                                                <Form.Label className={'left-align temp-text-box-label pl-1' + (this.state.selectedItem !== "" ? "" : " no-opacity")}>Make and model</Form.Label>
                                                <input
                                                    type="text"
                                                    id="autocomplete"
                                                    onChange={this.autocomplete}
                                                    onKeyUp={this.hanldeKeyup}
                                                    onKeyDown={this.hanldeKeydown}
                                                    value={this.state.selectedItem.fullDescription}
                                                    className="custom-input form-control"
                                                    placeholder="Make and model"
                                                />
                                                {this.state.searchItems.length > 0 && (
                                                    <ul id="makeAndModel" className="list-group">
                                                        {this.state.searchItems.map((item, idx) => (
                                                            <li
                                                                className={
                                                                    this.state.cursor === idx ? "active list-group-item" : "list-group-item"
                                                                }
                                                                key={idx}
                                                                onClick={() => this.selectItem(item)}
                                                                onKeyDown={evt => this.handleListKeydown(evt)}
                                                            >
                                                                {item.fullDescription}
                                                            </li>
                                                        ))}
                                                    </ul>
                                                )}

                                            </div>
                                            {this.state.selectedItem === "" && this.state.hasSelectedFin &&
                                                <div className="help-block mt-0">Make and model is required</div>
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 mt-2 text-lg-center text-md-center">
                        <div className="container">
                            <div className="row justify-content-center">
                                <div className="col-lg-10 col-12">
                                    <div className="ma-top-30px">
                                        <p className="text-16 font-weight-500">Is your car already financed</p>
                                    </div>
                                    <div className="row d-flex justify-content-center ma-top-30px">
                                        <div className="col-md-2 col-6">
                                            <button className={this.state.buttonYesClicked ? 'btn btn-block btn-solid-red font-weight-bold w-100' : 'btn btn-block btn-outline-red font-weight-bold w-100'} type="button" id="btnYes" onClick={this.handleYesButton}>Yes</button>
                                        </div>
                                        <div className="col-md-2 col-6">
                                            <button className={this.state.buttonNoClicked ? 'btn btn-block btn-solid-red font-weight-bold w-100' : 'btn btn-block btn-outline-red font-weight-bold w-100'} type="button" id="btnNo" onClick={this.handleNoButton}>No</button>
                                        </div>
                                    </div>

                                    <div className="col-12 p-0 mt-5">
                                        <p className={this.state.isFinanceYes ? 'text-left mb-1' : 'text-left mb-1 p-disabled'}><b>Where is it financed</b></p>
                                        <Dropdown
                                            id="financeHouse-select-dropdown"
                                            className="fit-full"
                                            onSelect={this.handleFinanceSelection}
                                            onToggle={this.handleSelectedFinanceHouseDropdownToggle}>
                                            <Dropdown.Toggle id="dropdown-basic" disabled={this.state.openDisabled}>
                                                <div className="row dropdown-height">
                                                    <div className="dropdown-basic-title-text col-11">
                                                        {this.state.selectedFinanceHouse}
                                                        {!this.state.selectedFinanceHouse &&
                                                            <p>Choose an option</p>
                                                        }
                                                    </div>
                                                    <Image src='Images/red-arrow-up-24-px.svg' className={this.state.selectedFinanceHouseDropdown ? 'visible' : 'invisible'} alt="" />
                                                    <Image src='Images/red-arrow-down-24-px.svg' className={this.state.selectedFinanceHouseDropdown ? 'invisible' : 'visible'} alt="" />
                                                </div>
                                            </Dropdown.Toggle>
                                            <Dropdown.Menu id='financeHouseDropDown'>
                                                {financeHouseDrop}
                                            </Dropdown.Menu>
                                        </Dropdown>
                                    </div>

                                    <div className="row justify-content-center">
                                        <div className="col-lg-3 col-md-3 col-xs-12 col-sm-12 pb-5">
                                            <Button className="btn btn-block btn-solid-red" id="submitButton" disabled={this.state.nextDisabled} onClick={this.handleClick}>Next</Button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        )
    }
}

const mapStateToProps = (state: any) => {
    return {
        profile: state.profile,
        auth: state.firebase.auth,
        sales: state.sales
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        redirectTo: (destination) => dispatch(navigateTo(destination)),
        dispatchSetCarDetails: (VehicleYear: number, MakeId: number, ModelId: number, MeriesId: number, MmCode: string, Description: string) => dispatch(setCarDetails(VehicleYear, MakeId, ModelId, MeriesId, MmCode, Description)),
        dispatchSetFinanceHouse: (financeHouse: any, financeHouseId: number) => dispatch(setFinanceHouse(financeHouse, financeHouseId))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(CarDetails);